import { useState } from 'react';

import { getMessageError } from 'utils/helpers';

import { useLogger } from 'hooks/useLogger/useLogger';

import { useRequestState } from './types';

export const useRequest = (): useRequestState => {
  const logger = useLogger();

  const [_errorMessage, _setErrorMessage] = useState<string | null>(null);
  const [_isError, _setError] = useState(false);
  const [_isLoading, _setLoading] = useState(false);
  const [_isSuccess, _setSuccess] = useState(false);

  const setLoading = () => {
    _setErrorMessage(null);
    _setError(false);
    _setLoading(true);
    _setSuccess(false);
  };

  const setError = (e: unknown, fallbackMessage?: string, log?: boolean) => {
    const message = getMessageError(e, fallbackMessage);

    _setErrorMessage(message);

    if (log) {
      logger.error(message);
    }

    _setError(true);
    _setLoading(false);
    _setSuccess(false);
  };

  const setSuccess = () => {
    _setErrorMessage(null);
    _setError(false);
    _setLoading(false);
    _setSuccess(true);
  };

  const errorMessage = () => {
    return _errorMessage;
  };

  const isLoading = () => {
    return _isLoading;
  };

  const isError = () => {
    return _isError;
  };

  const isSuccess = () => {
    return _isSuccess;
  };

  return {
    errorMessage,
    isLoading,
    isError,
    isSuccess,
    setLoading,
    setError,
    setSuccess,
  };
};

export default useRequest;
